<div class="dialog appendix-a">
  <div mat-dialog-title class="dialog-title">
    <span id="appendix-a-title" tabindex="-1" role="heading" aria-level="1">APPENDIX A: Technology/Solution Areas Taxonomy</span>
    <mat-icon class="close-icon" (click)="close()" aria-label="Close">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <mat-dialog-content>
    <!-- <p>Use the list below as a more comprehensive reference of Solution Areas when completing your Renewal Details.</p> -->
    <div class="solution-area-category" *ngFor="let group of solutionAreaCategories">
      <h3 class="category-title">{{ group.category }}</h3>
      <ul class="solution-areas-list">
        <li *ngFor="let item of group.items">{{ item }}</li>
      </ul>
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button class="flat-button" (click)="close()">Close</button>
  </div>
</div>
